import { useTranslation } from "react-i18next";
import i18next from "i18next";
import RadioGroup from "../RadioGroup/RadioGroup";
import clsx from "clsx";

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  const current = i18next.language?.toLowerCase?.() || "EN";

  return (
    <div className={clsx(["flex"])}>
      <RadioGroup
        onChange={(value: any) => changeLanguage(value)}
        options={[
          {
            label: "Español",
            value: "es",
          },
          {
            label: "English",
            value: "en",
          },
        ]}
        selected={current?.startsWith?.("es") ? "es" : "en"}
      />
    </div>
  );
};

export default LanguageSwitcher;
